import React, { useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useLanguage } from "../../../../contexts/LanguageContext";
import { reviews } from "../../../../utils/reviewsData";
import { review } from "../../../../utils/translations";
import useIsMobilei from "../../../../hooks/isMobile";
import "./reviews.css";

export default function Reviews() {
  const { isMobilei } = useIsMobilei();
  const { language } = useLanguage();
  const itemsPerGroup = 4;
  const totalGroups = Math.ceil(reviews.length / itemsPerGroup);
  const [currentGroup, setCurrentGroup] = useState(0);
  const isRtl = language === "ar";

  const handleNext = () => {
    if (currentGroup < totalGroups - 1) {
      setCurrentGroup(currentGroup + 1);
    }
  };

  const handleBack = () => {
    if (currentGroup > 0) {
      setCurrentGroup(currentGroup - 1);
    }
  };

  const handleDragEnd = (event, info) => {
    if (info.offset.x < -50 && currentGroup < totalGroups - 1) {
      setCurrentGroup(currentGroup + 1);
    } else if (info.offset.x > 50 && currentGroup > 0) {
      setCurrentGroup(currentGroup - 1);
    }
  };

  return (
    <>
      <div style={{ display: "flex", justifyContent: "center", marginTop: "30px", marginBottom: "20px" }}>
        <hr style={{ width: "50%", maxWidth: "500px", borderTop: "1px solid var(--secondary-color)" }} />
      </div>

      <div className={`reviews-header ${isRtl ? "rtl" : ""} ${isRtl ? "arab" : ""}`}>
        <h2 className="reviews-headerTitle">{review[language].reviews}</h2>
        <Link to="see-all-reviews" className="reviews-headerLink">
          {review[language].seeAll}
        </Link>
      </div>

      {isMobilei ? (
        <motion.div
          id="reviews-section"
          className="reviews-dragContainer"
          drag="x"
          dragConstraints={{ left: -10, right: 10 }}
          onDragEnd={handleDragEnd}
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.1 }}
          transition={{ duration: 0.5 }}
        >
          <div className="reviews-container">
            {reviews.slice(currentGroup * 4, currentGroup * 4 + 4).map((review, index) => (
              <motion.div key={index} className="reviews-reviewerCard" whileTap={{ scale: 0.95 }}>
                <div className="reviews-reviewerInfo">
                  <img src={review.image} alt={review.name} className="reviews-reviewerImage" />
                  <p className="reviews-reviewerName">{review[language].name}</p>
                </div>
                <p className="reviews-reviewerComment">{review[language].comment}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>
      ) : (
        <>
          <motion.div
            id="reviews-section"
            className="reviews-container"
            key={currentGroup}
            initial={{ opacity: 0, x: 300 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.1 }}
            transition={{duration : 0.5 }}
          >

            {reviews.slice(currentGroup * 4, currentGroup * 4 + 4).map((review, index) => (
              <motion.div key={index} className="reviews-reviewerCard" whileTap={{ scale: 0.95 }}>
                <div className="reviews-reviewerInfo">
                  <img src={review.image} alt={review.name} className="reviews-reviewerImage" />
                  <p className="reviews-reviewerName">{review[language].name}</p>
                </div>
                <p className="reviews-reviewerComment">{review[language].comment}</p>
              </motion.div>
            ))}
          </motion.div>

          <div className={`reviews-buttonsContainer ${isRtl ? "rtl" : ""}`}>
            {/*  */}
            <p className="reviews-button" onClick={handleBack}>{review[language].back}</p>
            <p className="reviews-button" onClick={handleNext}>{review[language].next}</p>
          </div>
        </>
      )}
    </>
  );
}